import { render } from "./findPassword.vue?vue&type=template&id=166a87c2&scoped=true"
import script from "./findPassword.vue?vue&type=script&lang=js"
export * from "./findPassword.vue?vue&type=script&lang=js"

import "./findPassword.vue?vue&type=style&index=0&id=166a87c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-166a87c2"

export default script